import styled from 'styled-components';

export const ChatWindowWrapper = styled.div`
  padding: 2rem;
  background: var(--color-white);
  border-radius: 8px;
  /* Subtracted header's and rio toolkit internal padding from the height of the messages section */
  height: calc(100dvh - 50px - 60px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: auto;
`;

export const ContentWrapper = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-right: 2rem;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--gray-light);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #fff;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-button {
    display: none;
  }

  scrollbar-width: thin;
  scrollbar-color: var(--gray-light) #fff;
`;

export const MessagesSection = styled.div`
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
